import { render } from "./modal.vue?vue&type=template&id=93348c3a"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"
script.render = render

export default script